/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, ReactNode, createContext, useState } from "react";
import Cookies from "js-cookie";
import config from "../utils/config";

import {
  AuthContextData,
  AuthProviderProps,
  UserData,
} from "../interface/useAuth";
import {
  ClearDataFunction,
  LoadDataFunction,
  RefetchDataFunction,
  SetCookieTokenFunction,
  SetDataFunction,
} from "../types/useAuth";
import { JobIdDetailsProps, defaultJobDetails } from "../interface/job_board";

const AuthContext = createContext<AuthContextData | undefined>(undefined);

export function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be called within a AuthProvider");
  }
  return context;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<UserData | null>(null);
  const [token, setToken] = useState<string>("");
  const [openNotification, setOpenNotification] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [refreshToken, setRefreshToken] = useState<string | null>(null);
  const [tokenBalance, setTokenBalance] = useState<number>(0);

  // state to hold job information
  const [jobInfo, setJobInfo] = useState<JobIdDetailsProps>(defaultJobDetails);

  const set_data: SetDataFunction = async (data: UserData) => {
    Cookies.set(config.key.user, JSON.stringify(data));
    setUser(data);
  };

  const handleNotification = (data: boolean) => setOpenNotification(data);
  const handleIsNotification = (data: boolean) => setIsNotification(data);
  const loadData: LoadDataFunction = async () => {
    const tokenCookie = Cookies.get(config.key.token);
    if (tokenCookie) {
      setToken(tokenCookie);
    }
    const userCookie = Cookies.get(config.key.user);
    if (userCookie) {
      setUser(JSON.parse(userCookie));
    }
    const refreshTokenCookie = Cookies.get(config.key.refreshToken);
    if (refreshTokenCookie) {
      setRefreshToken(refreshTokenCookie);
    }
    const loadJobInfo = Cookies.get(config.key.jobInformation);
    if (loadJobInfo) {
      setJobInfo(JSON.parse(loadJobInfo));
    }
  };

  const refetchData: RefetchDataFunction = () => {};
  const clear_data: ClearDataFunction = () => {
    Cookies.remove(config.key.user);
    Cookies.remove(config.key.token);
    Cookies.remove(config.key.refreshToken);
    Cookies.remove(config.key.jobInformation);
    setToken("");
    setUser(null);
    setRefreshToken(null);
    setJobInfo(defaultJobDetails);
  };

  const updateTokenBalance = (newBalance: number) => {
    setTokenBalance(newBalance);
  };

  const set_cookie_token: SetCookieTokenFunction = async (data) => {
    setToken(data.accessToken);
    // Set the cookie using cookie-js
    Cookies.set(config.key.token, data?.accessToken, {
      path: "/", // Set path to root
    });
    setRefreshToken(data.refreshToken);
    Cookies.set(config.key.refreshToken, data?.refreshToken, {
      path: "/", // Set path to root
    });
  };
  return (
    <AuthContext.Provider
      value={{
        set_data,
        token,
        handleNotification,
        openNotification,

        handleIsNotification,
        isNotification,
        jobInfo,
        refreshToken,
        set_cookie_token,
        loadData,
        user,
        refetchData,
        clear_data,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
